<template>
  <div class="user-wrapper w-100">
    <profile/>
  </div>
</template>
<script>
import profile from './Profile.vue';
import ProfileHeader from '@/components/header.vue';

export default {
  components: {
    profile,
    ProfileHeader,
  },
  data() {
    return {};
  },
};
</script>
